import WebSocketClient from '@clients/web-socket.client';
import { INewEcoAgreement, IUpdateEcoAgreement,
  IRespondEcoAgreement, IRespondEcoAgreementUpdate, IEndEcoAgreement, IUpdateEcoPurchase, 
  INewEcoPurchase, INewEcoTransfer, IUpdateEcoTransfer, IEcoSetting } from '@app-types/websocket/economy.types';

const socket = WebSocketClient.getInstance();

/** Email the economy PDF using the same request flow as saveChat. */
export function saveEconomy(): boolean {
  if (!socket.hasConnection()) {return false;}
  socket.sendJSON({saveEconomy: true});
  return true;
}

export function newAgreement(agreement: INewEcoAgreement) {
  if (agreement.amount) {
    agreement.amount = agreement.amount*100;
  }
  socket.sendJSON({
    ecoNewAgreement: agreement,
  });
}

export function updateAgreement(update: IUpdateEcoAgreement) {
  if (update.amount) {
    update.amount = Math.trunc(update.amount*100);
  }
  socket.sendJSON({
    ecoUpdateAgreement: update,
  });
}

export function respondAgreement(response: IRespondEcoAgreement) {
  socket.sendJSON({
    ecoRespondAgreement: response,
  });
}

export function respondAgreementUpdate(response: IRespondEcoAgreementUpdate) {
  socket.sendJSON({
    ecoRespondAgreementUpdate: response,
  });
}

export function seenAgreement(agreementId: number) {
  socket.sendJSON({
    ecoSeenAgreement: agreementId,
  });
}

export function archiveAgreement(agreementId: number) {
  socket.sendJSON({
    ecoArchiveAgreement: agreementId,
  });
}

export function archiveAgreementUpdate(agreementId: number) {
  socket.sendJSON({
    ecoArchiveAgreementUpdate: agreementId,
  });
}

export function endAgreement(endAgreementData: IEndEcoAgreement) {
  socket.sendJSON({
    ecoEndAgreement: endAgreementData,
  });
}

export function newPurchase(purchase: INewEcoPurchase) {
  if (purchase.amount) {
    purchase.amount = purchase.amount*100;
  }
  socket.sendJSON({
    ecoNewPurchase: purchase,
  });
}

export function updatePurchase(update: IUpdateEcoPurchase) {
  if (update.amount) {
    update.amount = Math.trunc(update.amount*100);
  }
  socket.sendJSON({
    ecoUpdatePurchase: update,
  });
}

export function seenPurchase(purchaseId: number) {
  socket.sendJSON({
    ecoSeenPurchase: purchaseId,
  });
}

export function archivePurchase(purchaseId: number) {
  socket.sendJSON({
    ecoArchivePurchase: purchaseId,
  });
}

export function deletePurchase(purchaseId: number) {
  socket.sendJSON({
    ecoDeletePurchase: purchaseId,
  });
}

export function restorePurchase(purchaseId: number) {
  socket.sendJSON({
    ecoRestorePurchase: purchaseId,
  });
}

export function disputePurchase(purchaseId: number) {
  socket.sendJSON({
    ecoDisputePurchase: purchaseId,
  });
}

export function newTransfer(transfer: INewEcoTransfer) {
  if (transfer.sum) {
    transfer.sum = transfer.sum*100;
  }
  socket.sendJSON({
    ecoNewTransfer: transfer,
  });
}

export function updateTransfer(update: IUpdateEcoTransfer) {
  if (update.sum) {
    update.sum = Math.trunc(update.sum*100);
  }
  socket.sendJSON({
    ecoUpdateTransfer: update,
  });
}

export function seenTransfer(transferId: number) {
  socket.sendJSON({
    ecoSeenTransfer: transferId,
  });
}

export function archiveTransfer(transferId: number) {
  socket.sendJSON({
    ecoArchiveTransfer: transferId,
  });
}

export function deleteTransfer(transferId: number) {
  socket.sendJSON({
    ecoDeleteTransfer: transferId,
  });
}

export function restoreTransfer(transferId: number) {
  socket.sendJSON({
    ecoRestoreTransfer: transferId,
  });
}

export function disputeTransfer(transferId: number) {
  socket.sendJSON({
    ecoDisputeTransfer: transferId,
  });
}

export function updateSettings(settings: IEcoSetting[]) {
  socket.sendJSON({
    ecoSettings: settings,
  });
}


// WEBPACK FOOTER //
// ./src/services/economy/economy.websocket.ts